export enum ModalitiesEnum {
  Residencial = 1001,
  Comercial = 1002,
};
